export enum BreadcrumbEvents {
    Reload = 'events.breadcrumb.reload'
}
